import * as tslib_1 from "tslib";
import { AfterViewInit, ChangeDetectorRef, ElementRef, EventEmitter, Renderer2, ViewContainerRef } from '@angular/core';
import { distinctUntilChanged } from 'rxjs/operators';
import { util } from '../../../classes/util';
import { ESRI } from '../../../esri-loader-util';
import { BooleanConverter, InputConverter, JSONConverter, NumberConverter } from '../../../inputConverter';
import { GisToolsService } from '../../../services/gis-tools.service';
import { VideoLogService } from '../../../services/video-log.service';
import { BaseComponent } from '../../base.component';
var Graphic;
var WebMercatorUtils;
var VideoLogViewerComponent = /** @class */ (function (_super) {
    tslib_1.__extends(VideoLogViewerComponent, _super);
    function VideoLogViewerComponent(_vcf, gisToolsService, videoLogService, cdr, renderer) {
        var _this = _super.call(this, _vcf, true) || this;
        _this.gisToolsService = gisToolsService;
        _this.videoLogService = videoLogService;
        _this.cdr = cdr;
        _this.renderer = renderer;
        _this.latLongDebounce = 100;
        _this.firstZoom = false;
        _this.aoiString = '';
        _this.precision = 5;
        _this.buffer = 50;
        _this.directionalMarker = false;
        _this.markerSymbol = {};
        _this.positionChange = new EventEmitter();
        _this.openPopUp = new EventEmitter();
        _this.loadHistoricReport = new EventEmitter();
        _this.refreshViewer = _this.videoLogService.refreshViewer;
        _this.swapPanelEvent = new EventEmitter();
        _this.threeImageViewEnabled = false;
        _this.showThreeImages = false;
        _this.hideSwapBtn = true;
        _this.prevX = [0, 0, 0];
        _this.prevY = [0, 0, 0];
        _this.topPx = '25px';
        _this.bottomPx = '';
        _this.showLeft = true;
        _this.showCenter = true;
        _this.showRight = true;
        _this.hidePopUpButtons = false;
        _this.zoomFactor = 0.1; // Adjust this value to control the zoom factor
        _this.currentScale = [1, 1, 1];
        _this._mapClickActive = true;
        _this.followZoomDebounce = 10;
        _this.enablePopUpWindow = false;
        _this.toolTipText = '';
        _this.dragEventsSet = false;
        _this.isDragging = false;
        _this.initialX = 0;
        _this.initialY = 0;
        _this.setCrs = function (crs) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.videoLogService.resetVideoLog();
                        return [4 /*yield*/, this.videoLogService.goToSegmentAndSetOffset(crs.countyCode, crs.stateRouteNumber, crs.segmentNumber, crs.offset)];
                    case 1:
                        _a.sent();
                        if (this.videoLogService.image && this.enablePopUpWindow) { // popout window doesn't need to update marker
                            this.setVideoLogViewerMarker(this.videoLogService.image.latitude, this.videoLogService.image.longitude);
                            this._lat = this.videoLogService.image.latitude;
                            this._long = this.videoLogService.image.longitude;
                        }
                        this.cdr.detectChanges();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.swapPanels = function (isPopUp) {
            if (isPopUp === void 0) { isPopUp = false; }
            if (_this.threeImageViewEnabled) {
                if (!isPopUp) {
                    _this.swapPanelEvent.emit();
                }
                _this.videoLogService.swapPanelUpdate(_this.showThreeImages);
                _this.showThreeImages = !_this.showThreeImages;
                _this.topPx = !_this.showThreeImages ? '25px' : '';
                _this.bottomPx = !_this.showThreeImages ? '' : '0px';
                _this.leftImageDivRef.nativeElement.style.resize = !_this.showThreeImages ? 'none' : 'both';
                _this.rightImageDivRef.nativeElement.style.resize = !_this.showThreeImages ? 'none' : 'both';
                _this.middleImageDivRef.nativeElement.style.width = !_this.showThreeImages ? '100%' : '33%';
                if (isPopUp) {
                    _this.hidePopUpButtons = true;
                    _this.handlePopUp();
                }
            }
        };
        _this.goToMarker = util.debounce(function () {
            // Have to use any because ESRI's types are screwed up
            var goToOptions = {
                target: _this.markerGraphic,
                animate: true
            };
            if ((typeof _this.zoomOnPositionChange === 'string' && _this.zoomOnPositionChange
                && (_this.zoomOnPositionChange === 'zoom' || (_this.zoomOnPositionChange === 'first' && _this.firstZoom)))
                || (typeof _this.zoomOnPositionChange === 'boolean' && _this.zoomOnPositionChange)) {
                _this.firstZoom = false;
                goToOptions.zoom = _this.followZoomLevel;
            }
            _this.mapViewRef.goTo(goToOptions);
        }, _this.followZoomDebounce);
        _this.executePositionChange = util.debounce(function () {
            _this.onPositionChange(true);
        }, _this.latLongDebounce);
        return _this;
    }
    Object.defineProperty(VideoLogViewerComponent.prototype, "active", {
        get: function () { return this._active; },
        set: function (value) {
            BooleanConverter(value) ? this.activate() : this.deactivate();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VideoLogViewerComponent.prototype, "zoomOnPositionChange", {
        get: function () {
            return this.videoLogService.zoomOnPositionChange;
        },
        set: function (val) {
            if (typeof val === 'string') {
                val = val.toLocaleLowerCase().trim();
                if (val === 'true') {
                    val = 'follow';
                }
                else if (val === 'false') {
                    val = 'none';
                }
            }
            else {
                if (val) {
                    val = 'follow';
                }
                else {
                    val = 'none';
                }
            }
            this.videoLogService.zoomOnPositionChange = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VideoLogViewerComponent.prototype, "lat", {
        get: function () { return this._lat; },
        set: function (value) {
            this._lat = NumberConverter(value);
            this.executePositionChange();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VideoLogViewerComponent.prototype, "long", {
        get: function () { return this._long; },
        set: function (value) {
            this._long = value;
            this.executePositionChange();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VideoLogViewerComponent.prototype, "mapClickActive", {
        get: function () { return this._mapClickActive; },
        set: function (value) {
            if (this._mapClickActive !== value) {
                this._mapClickActive = value;
                this.setClickAction();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VideoLogViewerComponent.prototype, "followZoomLevel", {
        get: function () {
            return this.videoLogService.followZoomLevel;
        },
        set: function (val) {
            this.videoLogService.followZoomLevel = NumberConverter(val);
        },
        enumerable: true,
        configurable: true
    });
    VideoLogViewerComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.videoLogService.refreshViewer.subscribe(function () {
            _this.cdr.detectChanges();
        });
        this.videoLogService.imagedToggled.subscribe(function (imageName) {
            switch (imageName) {
                case 'Left':
                    _this.showLeft = !_this.showLeft;
                    break;
                case 'Center':
                    _this.showCenter = !_this.showCenter;
                    break;
                case 'Right':
                    _this.showRight = !_this.showRight;
                    break;
                default:
                    break;
            }
        });
        this.videoLogService.openThreeImageView.subscribe(function (open) {
            if (!_this.threeImageViewEnabled) {
                _this.hideSwapBtn = true;
            }
            else if (!_this.showThreeImages && open) {
                _this.swapPanels();
                _this.hideSwapBtn = false;
                _this.resetImages();
            }
            else if (_this.showThreeImages && !open) {
                _this.swapPanels();
                _this.hideSwapBtn = true;
            }
        });
    };
    VideoLogViewerComponent.prototype.activate = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([this.loadESRIClasses()])];
                    case 1:
                        _b.sent();
                        if (!!this.mapViewRef) return [3 /*break*/, 3];
                        _a = this;
                        return [4 /*yield*/, this.setupMapViewRef(this.mapViewRef)];
                    case 2:
                        _a.mapViewRef = _b.sent();
                        _b.label = 3;
                    case 3:
                        //the markerSymbol object will be empty if no input was given from the client app
                        if (JSON.stringify(this.markerSymbol) === '{}') {
                            if (this.directionalMarker) {
                                this.markerSymbol = {
                                    type: 'simple-marker',
                                    style: 'triangle',
                                    color: 'red',
                                    angle: 180,
                                    size: 15
                                };
                            }
                            else {
                                this.markerSymbol = {
                                    type: 'simple-marker',
                                    style: 'circle'
                                };
                            }
                        }
                        if (this._lat && this._long) {
                            this.setVideoLogViewerMarker(this._lat, this._long);
                            this.setVideoLogLocation();
                        }
                        this.setClickAction();
                        this.offsetSubscription = this.videoLogService.newOffset.pipe(distinctUntilChanged()).subscribe(function (image) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var e_1, _a, rmsOffsetsPromise, _b, rmsOffsets, rmsLocalOffsets, crsList, localcrslist, rmsLocalOffsets_1, rmsLocalOffsets_1_1, route;
                            return tslib_1.__generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0:
                                        if (!image) return [3 /*break*/, 2];
                                        this._lat = image.latitude;
                                        this._long = image.longitude;
                                        this.setVideoLogViewerMarker(this._lat, this._long);
                                        if (this.aoiString && this.aoiString !== '') {
                                            //when videolog's aoi is used, some locaitons lat / long does not always find the right crs.
                                            //Increasing this buffer helps. Subsequently, on videolog side, when aoi is used, it will look through crsList and match crs to get correct result.
                                            //This matching is also done below in setVideoLogLocation() when aoi is used to set location.
                                            this.buffer = 100;
                                        }
                                        rmsOffsetsPromise = void 0;
                                        if (this.videoLogService.crsSelection) {
                                            rmsOffsetsPromise = this.gisToolsService.getOffsetForLatLong(this._lat, this._long, this.buffer, 'latLong { latitude, longitude }, countyCode, stateRouteNumber, routeName, segmentNumber, offset, direction, distance, juris');
                                        }
                                        else {
                                            rmsOffsetsPromise = [{
                                                    countyCode: this.videoLogService.videoLog.countyCode,
                                                    direction: this.videoLogService.videoLog.direction,
                                                    distance: null,
                                                    latLong: { latitude: this._lat, longitude: this._long },
                                                    offset: image.offset,
                                                    routeName: this.videoLogService.videoLog.routeName,
                                                    segmentNumber: this.videoLogService.videoLog.segmentNumber,
                                                    stateRouteNumber: this.videoLogService.videoLog.stateRouteNumber
                                                }];
                                        }
                                        return [4 /*yield*/, Promise.all([
                                                rmsOffsetsPromise,
                                                !this.videoLogService.findinxlist ? [] : this.gisToolsService.getNearbyLocalIntersections(this._lat, this._long, this.buffer, 'countyCode, countyIXN, stateRouteNumber, streetName, streetNameIXN, stateRouteIXN, intersectionType')
                                            ])];
                                    case 1:
                                        _b = tslib_1.__read.apply(void 0, [_c.sent(), 2]), rmsOffsets = _b[0], rmsLocalOffsets = _b[1];
                                        crsList = [];
                                        if (rmsOffsets && rmsOffsets.length > 0) {
                                            crsList = rmsOffsets.filter(function (x) { return !['4', '8'].includes(x.juris); });
                                        }
                                        else {
                                            crsList.push({ countyCode: '', direction: '', distance: 0, latLong: { latitude: 0, longitude: 0 }, offset: '', routeName: '', segmentNumber: '', stateRouteNumber: '' });
                                        }
                                        localcrslist = [];
                                        if (rmsLocalOffsets && rmsLocalOffsets.length > 0) {
                                            try {
                                                for (rmsLocalOffsets_1 = tslib_1.__values(rmsLocalOffsets), rmsLocalOffsets_1_1 = rmsLocalOffsets_1.next(); !rmsLocalOffsets_1_1.done; rmsLocalOffsets_1_1 = rmsLocalOffsets_1.next()) {
                                                    route = rmsLocalOffsets_1_1.value;
                                                    if (route.stateRouteIXN === '0000') {
                                                        //local roads will have stateRouteIXN = "0000"
                                                        localcrslist.push(route);
                                                    }
                                                }
                                            }
                                            catch (e_1_1) { e_1 = { error: e_1_1 }; }
                                            finally {
                                                try {
                                                    if (rmsLocalOffsets_1_1 && !rmsLocalOffsets_1_1.done && (_a = rmsLocalOffsets_1.return)) _a.call(rmsLocalOffsets_1);
                                                }
                                                finally { if (e_1) throw e_1.error; }
                                            }
                                        }
                                        else {
                                            localcrslist = [];
                                        }
                                        this.buffer = 50;
                                        this.aoiString = '';
                                        this.positionChange.next({
                                            lat: this._lat,
                                            long: this._long,
                                            crsList: crsList,
                                            localCRSList: localcrslist
                                        });
                                        _c.label = 2;
                                    case 2:
                                        this.cdr.detectChanges();
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        this._active = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    VideoLogViewerComponent.prototype.deactivate = function () {
        this._lat = null;
        this._long = null;
        this.videoLogService.resetVideoLog();
        if (this.videoLogViewerHandler) {
            this.videoLogViewerHandler.remove();
        }
        if (this.markerGraphic) {
            this.mapViewRef.graphics.remove(this.markerGraphic);
            this.markerGraphic.destroy();
            this.markerGraphic = null;
        }
        if (this.offsetSubscription) {
            this.offsetSubscription.unsubscribe();
            this.offsetSubscription = null;
        }
        this._active = false;
    };
    VideoLogViewerComponent.prototype.loadESRIClasses = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(!Graphic || !WebMercatorUtils)) return [3 /*break*/, 2];
                        return [4 /*yield*/, Promise.all([ESRI.Graphic, ESRI.WebMercatorUtils])];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [_b.sent(), 2]), Graphic = _a[0], WebMercatorUtils = _a[1];
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    VideoLogViewerComponent.prototype.setClickAction = function () {
        var _this = this;
        if (this.mapClickActive) {
            this.videoLogViewerHandler = this.mapViewRef.on('click', function (event) {
                var geographicPoint = WebMercatorUtils.webMercatorToGeographic(event.mapPoint);
                _this._lat = parseFloat(geographicPoint.y.toFixed(_this.precision));
                _this._long = parseFloat(geographicPoint.x.toFixed(_this.precision));
                _this.firstZoom = true;
                _this.onPositionChange(true);
            });
        }
        else if (this.videoLogViewerHandler) {
            this.videoLogViewerHandler.remove();
        }
    };
    VideoLogViewerComponent.prototype.onPositionChange = function (fromClick) {
        if (this.active) {
            this.setVideoLogViewerMarker(this._lat, this._long);
            this.setVideoLogLocation(fromClick);
        }
    };
    VideoLogViewerComponent.prototype.setVideoLogViewerMarker = function (latitude, longitude) {
        var point = {
            type: 'point',
            latitude: latitude,
            longitude: longitude
        };
        if (this.markerGraphic) {
            var newGeometry = this.markerGraphic.geometry.clone();
            newGeometry.latitude = latitude;
            newGeometry.longitude = longitude;
            this.markerGraphic.geometry = newGeometry;
        }
        else {
            this.markerGraphic = new Graphic({
                geometry: point,
                symbol: this.markerSymbol
            });
            this.mapViewRef.graphics.add(this.markerGraphic);
        }
        if (this.directionalMarker && this.videoLogService.image) {
            if (this.videoLogService.images[this.videoLogService.image.sequenceNumber + 1]) {
                //update marker angle
                var curLat = latitude;
                var curLong = longitude;
                var nextLat = this.videoLogService.images[this.videoLogService.image.sequenceNumber + 1].latitude;
                var nextLong = this.videoLogService.images[this.videoLogService.image.sequenceNumber + 1].longitude;
                this.calculateAndSetMarkerAngle(curLat, curLong, nextLat, nextLong, point);
            }
            else {
                //use slope for prev offset when at the end of images, not accurate, but fine for only one offset
                var curLat = this.videoLogService.images[this.videoLogService.image.sequenceNumber - 1].latitude;
                var curLong = this.videoLogService.images[this.videoLogService.image.sequenceNumber - 1].longitude;
                var nextLat = latitude;
                var nextLong = longitude;
                this.calculateAndSetMarkerAngle(curLat, curLong, nextLat, nextLong, point);
            }
        }
        if ((typeof this.zoomOnPositionChange === 'boolean' && this.zoomOnPositionChange)
            || (typeof this.zoomOnPositionChange === 'string' && this.zoomOnPositionChange && this.zoomOnPositionChange !== 'none')) {
            this.goToMarker();
        }
    };
    VideoLogViewerComponent.prototype.calculateAndSetMarkerAngle = function (curLat, curLong, nextLat, nextLong, point) {
        var rise = nextLong - curLong;
        var run = nextLat - curLat;
        var angle = Math.atan2(rise, run);
        angle *= 180 / Math.PI;
        angle = angle < 0 ? angle + 360 : angle;
        this.markerSymbol.angle = angle;
        this.mapViewRef.graphics.remove(this.markerGraphic);
        this.markerGraphic = new Graphic({
            geometry: point,
            symbol: this.markerSymbol
        });
        this.mapViewRef.graphics.add(this.markerGraphic);
    };
    VideoLogViewerComponent.prototype.setVideoLogLocation = function (fromClick) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_2, _a, locations, prevYear, index, aoiArr, cty, rt, segStart, count, locations_1, locations_1_1, location_1;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.gisToolsService.getOffsetForLatLong(this._lat, this._long, this.buffer, 'countyCode, stateRouteNumber, segmentNumber, offset')];
                    case 1:
                        locations = _b.sent();
                        prevYear = this.videoLogService.currentYear ? this.videoLogService.currentYear : null;
                        this.videoLogService.resetVideoLog();
                        index = 0;
                        aoiArr = [];
                        if (this.aoiString && this.aoiString !== '') {
                            aoiArr = this.aoiString.split('|');
                            cty = aoiArr[0] ? aoiArr[0] : '';
                            rt = aoiArr[1] ? aoiArr[1] : '';
                            segStart = aoiArr[2] ? aoiArr[2] : '';
                            count = 0;
                            try {
                                for (locations_1 = tslib_1.__values(locations), locations_1_1 = locations_1.next(); !locations_1_1.done; locations_1_1 = locations_1.next()) {
                                    location_1 = locations_1_1.value;
                                    if (location_1.countyCode === cty) {
                                        if (rt === '') {
                                            index = count;
                                            break;
                                        }
                                        else if (location_1.stateRouteNumber === rt) {
                                            if (segStart === '') {
                                                index = count;
                                                break;
                                            }
                                            else if (location_1.segmentNumber === segStart) {
                                                index = count;
                                                break;
                                            }
                                        }
                                    }
                                    count++;
                                }
                            }
                            catch (e_2_1) { e_2 = { error: e_2_1 }; }
                            finally {
                                try {
                                    if (locations_1_1 && !locations_1_1.done && (_a = locations_1.return)) _a.call(locations_1);
                                }
                                finally { if (e_2) throw e_2.error; }
                            }
                        }
                        if (!(locations && locations.length > 0)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.videoLogService.goToSegmentAndSetOffset(locations[index].countyCode, locations[index].stateRouteNumber, locations[index].segmentNumber, locations[index].offset, fromClick)];
                    case 2:
                        _b.sent();
                        if (this.videoLogService.showHistoricVideoLog && prevYear && this.videoLogService.yearRange
                            && this.videoLogService.yearRange.years.includes(prevYear)) {
                            this.videoLogService.currentYear = prevYear;
                            this.loadHistoricReport.emit();
                        }
                        _b.label = 3;
                    case 3:
                        if (this.videoLogService.image) {
                            if (fromClick) {
                                this.firstZoom = true;
                            }
                            this.setVideoLogViewerMarker(this.videoLogService.image.latitude, this.videoLogService.image.longitude);
                            if (!this.dragEventsSet) {
                                this.middleImageRef.nativeElement.addEventListener('dragstart', function (event) { _this.handleDragStart(event); });
                                this.middleImageRef.nativeElement.addEventListener('dragend', function () { return _this.handleDragEnd(); });
                                this.middleImageRef.nativeElement.addEventListener('dragover', function (event) { return _this.handleDragOver(event); });
                                this.middleImageRef.nativeElement.addEventListener('drop', function (event) { _this.handleDrop(event); });
                                this.middleImageRef.nativeElement.addEventListener('drag', function (event) { _this.handleDrag(event); });
                                this.leftImageRef.nativeElement.addEventListener('dragstart', function (event) { _this.handleDragStart(event); });
                                this.leftImageRef.nativeElement.addEventListener('dragend', function () { return _this.handleDragEnd(); });
                                this.leftImageRef.nativeElement.addEventListener('dragover', function (event) { return _this.handleDragOver(event); });
                                this.leftImageRef.nativeElement.addEventListener('drop', function (event) { _this.handleDrop(event); });
                                this.leftImageRef.nativeElement.addEventListener('drag', function (event) { _this.handleDrag(event); });
                                this.rightImageRef.nativeElement.addEventListener('dragstart', function (event) { _this.handleDragStart(event); });
                                this.rightImageRef.nativeElement.addEventListener('dragend', function () { return _this.handleDragEnd(); });
                                this.rightImageRef.nativeElement.addEventListener('dragover', function (event) { return _this.handleDragOver(event); });
                                this.rightImageRef.nativeElement.addEventListener('drop', function (event) { _this.handleDrop(event); });
                                this.rightImageRef.nativeElement.addEventListener('drag', function (event) { _this.handleDrag(event); });
                                this.dragEventsSet = true;
                            }
                        }
                        this.cdr.detectChanges();
                        return [2 /*return*/];
                }
            });
        });
    };
    VideoLogViewerComponent.prototype.openPopUpWindow = function (pos) {
        if (this.enablePopUpWindow) {
            //send event to host app to open popup window
            if (pos === 'm' && !this.showThreeImages) {
                this.openPopUp.emit();
            }
            else {
                this.openPopUp.emit(pos);
            }
        }
    };
    VideoLogViewerComponent.prototype.handleDragStart = function (e) {
        this.isDragging = true;
        this.initialX = e.clientX;
        this.initialY = e.clientY;
        if (e.target instanceof HTMLDivElement || e.target instanceof HTMLImageElement) {
            this.imageBeingDragged = e.target instanceof HTMLDivElement ? e.target : e.target.parentElement;
            var emptyImage = document.createElement('img');
            // Set the src to be a 0x0 gif
            emptyImage.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
            e.dataTransfer.setDragImage(emptyImage, 0, 0);
        }
    };
    VideoLogViewerComponent.prototype.handleDragEnd = function () {
        if (this.isDragging) {
            this.isDragging = false;
        }
        this.imageBeingDragged.style.boxShadow = '';
    };
    VideoLogViewerComponent.prototype.handleDrag = function (e) {
        if (this.isDragging) {
            var deltaX = e.clientX - this.initialX;
            var deltaY = e.clientY - this.initialY;
            this.initialX = e.clientX;
            this.initialY = e.clientY;
            if (e.target instanceof HTMLDivElement || e.target instanceof HTMLImageElement) {
                this.imageBeingDragged = e.target instanceof HTMLDivElement ? e.target : e.target.parentElement;
                var currentX = parseFloat(getComputedStyle(this.imageBeingDragged).left) || 0;
                var currentY = parseFloat(getComputedStyle(this.imageBeingDragged).top) || 0;
                this.renderer.setStyle(this.imageBeingDragged, 'left', currentX + deltaX + "px");
                this.renderer.setStyle(this.imageBeingDragged, 'top', currentY + deltaY + "px");
                var imageIndex = this.imageBeingDragged === this.leftImageDivRef.nativeElement ? 0 : this.imageBeingDragged === this.middleImageDivRef.nativeElement ? 1 : 2;
                this.moveImageToTop(imageIndex);
                this.imageBeingDragged.style.boxShadow = '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)';
            }
        }
    };
    VideoLogViewerComponent.prototype.handleDragOver = function (e) {
        e.preventDefault();
        return false;
    };
    VideoLogViewerComponent.prototype.handleDrop = function (e) {
        e.stopPropagation(); // stops the browser from redirecting.
        this.imageBeingDragged.style.boxShadow = '';
        return false;
    };
    VideoLogViewerComponent.prototype.resetImages = function () {
        this.showLeft = true;
        this.showCenter = true;
        this.showRight = true;
        this.videoLogService.resetImageToggleButtons();
        this.prevX = [0, 0, 0];
        this.prevY = [0, 0, 0];
        this.currentScale = [1, 1, 1];
        this.leftImageRef.nativeElement.style.transform = 'none';
        this.leftImageRef.nativeElement.style.transformOrigin = '328px 188px';
        this.leftImageDivRef.nativeElement.style.top = '5px';
        this.leftImageDivRef.nativeElement.style.left = '5px';
        this.leftImageDivRef.nativeElement.style.height = 'auto';
        this.leftImageDivRef.nativeElement.style.width = '33%';
        this.middleImageRef.nativeElement.style.transform = 'none';
        this.middleImageRef.nativeElement.style.transformOrigin = !this.showThreeImages ? '' : '328px 188px';
        this.middleImageDivRef.nativeElement.style.top = !this.showThreeImages ? '' : '5px';
        this.middleImageDivRef.nativeElement.style.left = !this.showThreeImages ? '' : '0';
        this.middleImageDivRef.nativeElement.style.right = !this.showThreeImages ? '' : '0';
        this.middleImageDivRef.nativeElement.style.height = !this.showThreeImages ? '100%' : 'auto';
        this.middleImageDivRef.nativeElement.style.width = !this.showThreeImages ? '100%' : '33%';
        this.rightImageRef.nativeElement.style.transform = 'none';
        this.rightImageRef.nativeElement.style.transformOrigin = '328px 188px';
        this.rightImageDivRef.nativeElement.style.top = '5px';
        this.rightImageDivRef.nativeElement.style.right = '5px';
        this.rightImageDivRef.nativeElement.style.left = '';
        this.rightImageDivRef.nativeElement.style.height = 'auto';
        this.rightImageDivRef.nativeElement.style.width = '33%';
    };
    VideoLogViewerComponent.prototype.zoomImage = function (e, imageNumber) {
        e.preventDefault();
        var target = e.target;
        if (target instanceof HTMLImageElement) {
            var x = this.prevX[imageNumber], y = this.prevY[imageNumber];
            if (this.currentScale[imageNumber] > 1 && this.currentScale[imageNumber] < 3) {
                x = e.clientX - target.x;
                this.prevX[imageNumber] = x;
                y = e.clientY - target.y;
                this.prevY[imageNumber] = y;
            }
            this.currentScale[imageNumber] += e.deltaY > 0 ? -this.zoomFactor : this.zoomFactor;
            // Set maximum and minimum zoom level
            this.currentScale[imageNumber] = Math.max(1, Math.min(3, this.currentScale[imageNumber]));
            //last scrolled image will be on top of others
            this.moveImageToTop(imageNumber);
            target.style.transformOrigin = x + "px " + y + "px";
            target.style.transform = "scale(" + this.currentScale[imageNumber] + ")";
        }
    };
    VideoLogViewerComponent.prototype.moveImageToTop = function (imageNumber) {
        switch (imageNumber) {
            case 0:
                this.leftImageDivRef.nativeElement.style.zIndex = '11';
                this.middleImageDivRef.nativeElement.style.zIndex = '10';
                this.rightImageDivRef.nativeElement.style.zIndex = '9';
                break;
            case 1:
                this.leftImageDivRef.nativeElement.style.zIndex = '10';
                this.middleImageDivRef.nativeElement.style.zIndex = '11';
                this.rightImageDivRef.nativeElement.style.zIndex = '10';
                break;
            case 2:
                this.leftImageDivRef.nativeElement.style.zIndex = '10';
                this.middleImageDivRef.nativeElement.style.zIndex = '10';
                this.rightImageDivRef.nativeElement.style.zIndex = '11';
                break;
            default:
                break;
        }
    };
    VideoLogViewerComponent.prototype.handlePopUp = function () {
        if (this.videoLogService.image) {
            var url = new URL(window.location.href);
            var pos = url.searchParams.get('pos');
            this.showThreeImages = false;
            //if pos is 'm' do nothing
            if (pos === 'l') {
                this.videoLogService.image.url = this.videoLogService.image.lurl;
            }
            else if (pos === 'r') {
                this.videoLogService.image.url = this.videoLogService.image.rurl;
            }
            this.leftImageDivRef.nativeElement.style.top = '';
            this.leftImageDivRef.nativeElement.style.left = '';
            this.leftImageDivRef.nativeElement.style.height = '';
            this.leftImageDivRef.nativeElement.style.width = '';
            this.middleImageDivRef.nativeElement.style.height = '100%';
            this.middleImageDivRef.nativeElement.style.width = '100%';
            this.rightImageDivRef.nativeElement.style.top = '';
            this.rightImageDivRef.nativeElement.style.right = '';
            this.rightImageDivRef.nativeElement.style.left = '';
            this.rightImageDivRef.nativeElement.style.height = '';
            this.rightImageDivRef.nativeElement.style.width = '';
            //also disable the swapPanelBtn
            this.hideSwapBtn = true;
        }
    };
    tslib_1.__decorate([
        InputConverter(NumberConverter),
        tslib_1.__metadata("design:type", Number),
        tslib_1.__metadata("design:paramtypes", [Number])
    ], VideoLogViewerComponent.prototype, "long", null);
    tslib_1.__decorate([
        InputConverter(NumberConverter),
        tslib_1.__metadata("design:type", Number)
    ], VideoLogViewerComponent.prototype, "precision", void 0);
    tslib_1.__decorate([
        InputConverter(NumberConverter),
        tslib_1.__metadata("design:type", Number)
    ], VideoLogViewerComponent.prototype, "buffer", void 0);
    tslib_1.__decorate([
        InputConverter(JSONConverter),
        tslib_1.__metadata("design:type", Object)
    ], VideoLogViewerComponent.prototype, "markerSymbol", void 0);
    tslib_1.__decorate([
        InputConverter(NumberConverter),
        tslib_1.__metadata("design:type", Number)
    ], VideoLogViewerComponent.prototype, "zoomFactor", void 0);
    return VideoLogViewerComponent;
}(BaseComponent));
export { VideoLogViewerComponent };
